import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchLeagues = () => api.get("/leagues").then((r) => r.data);
export const fetchMatches = (params = {}) =>
  api.get("/matches", { params }).then((r) => r.data);
export const fetchMatch = (id) => api.get(`/matches/${id}`).then((r) => r.data);
export const fetchStandings = (league) =>
  api.get(`/standings`, { params: { league } }).then((r) => r.data);
export const fetchScorers = (league) =>
  api.get(`/top-scorers`, { params: { league } }).then((r) => r.data);
export const fetchTicker = () => api.get("/live-ticker").then((r) => r.data);
export const fetchOverview = () => api.get("/stats/overview").then((r) => r.data);
export const generatePrediction = (matchId) =>
  api.post(`/predictions/${matchId}`).then((r) => r.data);
export const getPrediction = (matchId) =>
  api.get(`/predictions/${matchId}`).then((r) => r.data);
export const fetchMatchStats = (matchId) =>
  api.get(`/matches/${matchId}/stats`).then((r) => r.data);
